export default __webpack_public_path__ + "static/media/InfoAlert.235a9e63.svg";